/** CO display: "CO #n" plus description only when it is not a generic "CO n" / "co n". */

export function isGenericCoDescription(coNumber: number | string, description?: string | null): boolean {
  const n = String(coNumber ?? '').trim()
  if (!n) return false
  const norm = String(description || '').replace(/[#.\-_/]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase()
  return !norm || norm === `co ${n}` || norm === `c/o ${n}` || norm === n
}

export function formatCoLabel(coNumber: number | string, description?: string | null): string {
  const n = coNumber ?? ''
  const label = `CO #${n}`
  if (isGenericCoDescription(n, description)) return label
  return `${label} — ${String(description).trim()}`
}

export function isCoLine(itemId?: string | null): boolean {
  return /^CO-/i.test(String(itemId || '').trim())
}

export function isPayAppLockedForLineEdits(status?: string | null): boolean {
  const s = String(status || '').toLowerCase()
  return s === 'submitted' || s === 'paid' || s === 'payment_received'
}
